import axios from "axios";
import { baseURL } from "../config/index";
import { getAuthenticationParameters } from "../utils/Functions";
import secureLocalStorage from "react-secure-storage";

const redirectToLogin = (role) => {
  if (
    role === "super user" ||
    role === "support" ||
    role === "relationship manager"
  ) {
    window.location.href = "/admin/login";
  } else if (role === "hospital" || role === "company" || role === "agency") {
    window.location.href = "/parter/login";
  } else {
    window.location.href = "/";
  }
};

const logout = (role) => {
  console.log("this is log", role);
  secureLocalStorage.clear();
  localStorage.clear();

  if (
    role === "super user" ||
    role === "support" ||
    role === "relationship manager"
  ) {
    window.location.href = "/admin/login";
  } else if (role === "hospital" || role === "company" || role === "agency") {
    window.location.href = "/parter/login";
  } else {
    window.location.href = "/";
  }
};

const api = axios.create({ baseURL });

api.interceptors.request.use(
  async (config) => {
    const { token, expiresIn, refreshToken, id, role } =
      await getAuthenticationParameters();

    if (!token || !expiresIn || !refreshToken || !id || !role) {
      redirectToLogin(role);
      logout(role);
      return Promise.reject(new Error("Missing authentication parameters"));
    }
    // console.log("newToken", token);
    const expDate = new Date(Number(expiresIn));
    const currentDate = new Date();

    if (expDate < currentDate) {
      try {
        const response = await axios.post(`${baseURL}/api/v1/${role}/login`, {
          refreshToken,
          id,
        });
        console.log("newToken", response);
        const newToken = response.data.data.token;
        const newExpiresIn = response.data.data.expiresIn;
        console.log("newToken", newToken);
        secureLocalStorage.setItem("token", newToken);
        secureLocalStorage.setItem("expiresIn", newExpiresIn);

        config.headers["Authorization"] = `Bearer ${newToken}`;
      } catch (error) {
        redirectToLogin(role);
        logout();
        return Promise.reject(error);
      }
    } else {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
